import React from "react";

export default function Logo({ light = true, compact = false }) {
  return (
    <img src={light ? "/logo-light.png" : "/logo-dark.png"} alt="Honest Water LLC" width="640" height="334"
      className={`block h-auto transition-[width] duration-500 ${compact ? "w-[112px] md:w-[124px]" : "w-[124px] md:w-[168px]"}`} />
  );
}
